import React from 'react';
import { useLang } from '../context/LanguageContext';

const Marquee = () => {
  const { lang } = useLang();
  const items = lang === 'fr'
    ? ['Piercing d’Exception', 'Tatouage Signé', 'Matériel Stérile', 'Sans Rendez-vous', 'Bijoux Or & Titane', 'Villiers-sur-Marne']
    : ['Exceptional Piercing', 'Signature Tattoo', 'Sterile Equipment', 'Walk-ins Welcome', 'Gold & Titanium Jewelry', 'Villiers-sur-Marne'];

  const loop = [...items, ...items];
  return (
    <div className="marquee">
      <div className="marquee-track">
        {loop.map((it, i) => (
          <span key={`mq-${i}-${it}`} className="marquee-item flex items-center">
            {it}
            <span className="marquee-star ml-[60px]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
